<template>
  <div class="member-vehicles" v-if="member">
    <vehicle-list
        :organization-id="member.organization.id"
        :organization-name="member.organization.name"
        :customer-id="member.customer.id"
        :customer-name="member.customer.firstname + ' ' + member.customer.lastname"
        :member-id="member.id"
    />
  </div>
</template>

<script>
import VehicleList from "@/components/elements/VehicleList.vue";

export default {
  components: { VehicleList },

  computed: {
    member() {
      return this.$parent.member ?? null
    },
  },
}
</script>

<style lang="scss">
</style>
